export let rules = {
    empty: [v => !!v || "กรุณากรอกข้อมูล",
    // v => /^[ก-๏A-Za-z0-9]+$/.test(v) || "กรุณากรอกข้อมูลให้ถูกต้อง",
    v => ((!!v) ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
    v => ((!!v || v) ? v.length <= 50 : false) || "ข้อความต้องมีความยาวไม่เกิน 50 ตัวอักษร"],
    empty_longtext: [v => !!v || "กรุณากรอกข้อมูล",
    // v => /^[ก-๏A-Za-z0-9]+$/.test(v) || "กรุณากรอกข้อมูลให้ถูกต้อง",
    v => ((!!v) ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
    v => ((!!v || v) ? v.length <= 100 : false) || "ข้อความต้องมีความยาวไม่เกิน 100 ตัวอักษร"],
    empty_link: [v => !!v || "กรุณากรอกข้อมูล",
    // v => /^[ก-๏A-Za-z0-9]+$/.test(v) || "กรุณากรอกข้อมูลให้ถูกต้อง",
    v => ((!!v) ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
    v => ((!!v || v) ? v.length <= 1000 : false) || "ข้อความต้องมีความยาวไม่เกิน 1000 ตัวอักษร"],
    pick_date_rules: [v => !!v || "กรุณาเลือกวันที่"],
    price_rulse: [v => /^[0-9]+$/.test(v) || "กรุณากรอกจำนวนให้ถูกต้อง",
    v => v >= 0 || "ราคาต้องมากกว่าหรือเท่ากับ 0 บาท", v => ((v) ? v == 0 ? true : v[0] != "0" : true) || "ราคาไม่ควรเริ่มด้วย'0'"],
    phone_rules: [
        v => !!v || "กรุณากรอกหมายเลขโทรศัพท์มือถือ",
        v => v.length <= 12 || "กรุณากรอกหมายเลขโทรศัพท์มือถือ 10 หลัก",
        v => v.length >= 12 || "กรุณากรอกหมายเลขโทรศัพท์มือถือ 10 หลัก",
        v => ((v) ? v[0] == "0" : true) || "เบอร์โทรศัพท์ต้องขึ้นต้นด้วยเลข '0'"
    ],
    tel_rules: [
        v => !!v || "กรุณากรอกหมายเลขโทรศัพท์",
        v => /^[0-9+-]+$/.test(v) || "กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง",
        v => (!!v ? v.length == 11 || v.length == 12 : false) || "กรุณากรอกหมายเลขโทรศัพท์ 9-10 หลัก",
        // v => v.length >= 11 || "กรุณากรอกหมายเลขโทรศัพท์ 9 หลัก",
        v => ((v) ? v[0] == "0" : true) || "เบอร์โทรศัพท์ต้องขึ้นต้นด้วยเลข '0'"
    ],
    tel_location_rules: [
        v => !!v || "กรุณากรอกหมายเลขโทรศัพท์",
        v => (!!v ? v.length == 11 || v.length == 12 : false) || "กรุณากรอกหมายเลขโทรศัพท์ 9-10 หลัก",
        // v => v.length >= 10 || "กรุณากรอกหมายเลขโทรศัพท์ 9-10 หลัก",
        v => ((v) ? v[0] == "0" : true) || "เบอร์โทรศัพท์ต้องขึ้นต้นด้วยเลข '0'"
    ],
    email_rules: [
        v => !!v || "กรุณากรอกอีเมล",
        v => ((!!v) ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
        v => /.+@.+\.+/.test(v) || "กรุณากรอกอีเมลให้ถูกต้อง",
        v => /.+@.+\.+([A-Za-z])+$/.test(v) || "กรุณากรอกอีเมลให้ถูกต้อง",
        v => !/([ก-๏ ])/.test(v) || "กรุณากรอกอีเมลให้ถูกต้อง",
        v => (!!v ? v.length <= 100 : false) || "ข้อความต้องมีความยาวไม่เกิน 100 ตัวอักษร",
    ],
    staff_user_rules: [
        (v) => !!v || "กรุณากรอกข้อมูล",
        v => ((!!v) ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
        v => /^[A-Za-z0-9._-]+$/.test(v) || "ต้องเป็นภาษาอังกฤษ ตัวเลขและ . - _ เท่านั้น",
        (v) => (!!v ? v.length >= 3 : false) || "ต้องความยาวอย่างน้อย 3 ตัว",
        (v) => (!!v ? v.length <= 20 : false) || "ต้องความยาวไม่เกิน 20 ตัว",
    ],
    staff_name_rules: [v => !!v || "กรุณากรอกข้อมูล",
    v => /^[ก-๏]+$/.test(v) || "ต้องเป็นภาษาไทยเท่านั้น",
    v => ((!!v) ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
    v => (!!v ? v.length <= 50 : false) || "ข้อความต้องมีความยาวไม่เกิน 50 ตัวอักษร"],
    staff_position_rules: [
        // v => (v ? v.length <= 50 : false) || "ข้อความมีความยาวมากเกินไป"],
        v => ((v) ? v[0] != " " : true) || "ห้ามขึ้นต้นด้วยค่าว่าง",
        v => (v ? v.length <= 50 : true) || "ข้อความต้องมีความยาวไม่เกิน 50 ตัวอักษร"],
    staff_ps_rules: [
        // v => (v ? v.length <= 50 : false) || "ข้อความมีความยาวมากเกินไป"],
        v => ((v) ? v[0] != " " : true) || "ห้ามขึ้นต้นด้วยค่าว่าง",
        v => (v ? v.length <= 200 : true) || "ข้อความต้องมีความยาวไม่เกิน 200 ตัวอักษร"],
    location_link_rules: [
        v => ((v) ? v[0] != " " : true) || "ห้ามขึ้นต้นด้วยค่าว่าง",
        v => (v ? v.length <= 255 : true) || "ข้อความต้องมีความยาวไม่เกิน 255 ตัวอักษร"],
    location_email_rules: [
        v => (v ? (/.+@.+\.+/.test(v)) : true) || "กรุณากรอกอีเมลให้ถูกต้อง",
        v => (v ? (/.+@.+\.+([A-Za-z])+$/.test(v)) : true) || "กรุณากรอกอีเมลให้ถูกต้อง",
        v => (v ? (!/([ก-๏ ])/.test(v)) : true) || "กรุณากรอกอีเมลให้ถูกต้อง",
        v => v ? v.length <= 100 : true || "ข้อความต้องมีความยาวไม่เกิน 100 ตัวอักษร",
    ],
    location_name_rules: [v => !!v || "กรุณากรอกข้อมูล",
    // v => /^[ก-๏A-Za-z0-9]+$/.test(v) || "กรุณากรอกข้อมูลให้ถูกต้อง",
    v => ((!!v) ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
    v => ((!!v) ? v.length <= 150 : false) || "ข้อความต้องมีความยาวไม่เกิน 150 ตัวอักษร"],

}